<app-lms-modal-frame [title]="'New Region Details'" [pageHeadWidth]="300">
  <div modal-body class="container-fluid">
    <div class="row center-screen">
      <div class="container-sm center-container">
        <form [formGroup]="regionForm">
          <table class="table table-striped table-auto table-sm">
            <tbody class="field-4column-label">
              <tr>
                <td>Region name</td>
                <td>
                  <input formControlName="region" type="text" lmsNoSpecials toUppercase required>
                  <div *ngIf="regionForm.controls.region?.errors?.required && submitted" class="error-label">
                    Region name is required
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </form>

      </div>
    </div>
  </div>

  <div modal-actions class="flex-container">
    <button class="btn btn-primary btn-sm" mdbRipple type="button" (click)="close()">Close</button>
    <button class="btn btn-primary btn-sm" mdbRipple type="button" (click)="saveRegion()">Save region</button>
  </div>
</app-lms-modal-frame>
